import React, { useState, useEffect } from "react";

const CountdownTimer = ({ initialMinutes = 15, styles }) => {
  const [time, setTime] = useState(initialMinutes * 60); // Convert minutes to seconds

  useEffect(() => {
    const timerInterval = setInterval(() => {
      setTime((prevTime) => {
        if (prevTime <= 0) {
          clearInterval(timerInterval); // Stop the timer
          return 0;
        }
        return prevTime - 1;
      });
    }, 1000);

    return () => clearInterval(timerInterval); // Cleanup on unmount
  }, []);

  // Format time as mm:ss
  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  return (
    <div>
      <p style={{ ...styles }}>{formatTime(time)} sec left</p>
    </div>
  );
};

export default CountdownTimer;
